import React from "react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="saas-lp-hero">
      <div className="saas-lp-inner saas-lp-hero__inner">
        <p className="saas-lp-eyebrow">
          <span className="saas-lp-eyebrow__line" aria-hidden="true" />
          Built for growth
          <span className="saas-lp-eyebrow__line" aria-hidden="true" />
        </p>

        <h1 className="saas-lp-hero__title">
          Run your business on{" "}
          <span className="saas-lp-gradient saas-lp-gradient--cyan">one</span>{" "}
          <span className="saas-lp-gradient saas-lp-gradient--purple">platform</span>
        </h1>

        <p className="saas-lp-hero__subtitle">
          CRM, invoicing, e-commerce, staff management, and automation — connected in the
          Beentara ecosystem so your team works from one place.
        </p>

        <div className="saas-lp-hero__actions">
          <Link to="/signup?plan=starter" className="saas-btn saas-btn--primary saas-btn--lg">
            Start Free Trial
          </Link>
          <Link to="/compare" className="saas-btn saas-btn--secondary saas-btn--lg">
            Compare plans
          </Link>
        </div>

        <div className="saas-lp-hero__scroll" aria-hidden="true" />
      </div>
    </section>
  );
}
